module.exports = __webpack_public_path__ + "static/media/slider-arrows.c6c99269.svg";